var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-loading",style:({
    width: _vm.width + 'px',
    height: _vm.height + 'px',
    borderRadius: _vm.borderRadius + 'px',
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }